import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { MembershipExpirationsTab } from '@/features/dashboard/tabs/membership-expirations-tab'

export const Route = createFileRoute(
  '/_authenticated/dashboard/membership-expirations'
)({
  beforeLoad: requireSuperAdmin,
  component: MembershipExpirationsTab,
})
